export default "__VITE_ASSET__CVo7PoOJ__"